import React from "react";
import { TwTabs as Tabs } from "@virkesborsen/ui-component-library";
import { Chart } from "../components/Charts/Charts";
import { useMetricData } from "../hooks/UseMetricData";
import { useSubscription } from "../../context/SubscriptionCheckoutContext";
import { SubscriptionCoverBanner } from "../components/SubscriptionCovers";

export default function BarChartWidget() {
  const { openCheckout } = useSubscription();
  const { areaAge, volumeAge, propDfr } = useMetricData();

  const [ageGraphView, setAgeGraphView] = React.useState("area");

  const handlePlus = () => {
    openCheckout();
  };

  const ageLabels = [
    "0-10",
    "10-20",
    "20-30",
    "30-40",
    "40-50",
    "50-60",
    "60-70",
    "70-80",
    "80-90",
    "90-100",
    "100+",
  ];

  return (
    <>
      <div className="flex justify-end px-4">
        <div className="bg-cloud-200 rounded-lg-alt items-center justify-center">
          <Tabs
            defaultValue="area"
            tabs={[
              {
                label: "Areal",
                value: "area",
              },
              {
                label: "Volym",
                value: "volume",
              },
            ]}
            onClick={(value) => setAgeGraphView(value)}
          />
        </div>
      </div>
      <div className="flex flex-col space-y-3 px-4 relative">
        {!propDfr ? (
          <SubscriptionCoverBanner
            onClick={handlePlus}
            label="Åldersfördelning"
          />
        ) : null}
        <div style={!propDfr ? { filter: "blur(9px)" } : {}}>
          {areaAge && ageGraphView == "area" ? (
            <Chart
              data={ageLabels.map((age, index) => ({
                age: age,
                area: areaAge[index],
                unit: "ha",
              }))}
              dataKey={{
                xAxis: "age",
              }}
              dataset={[
                {
                  color: "#7C6ED9",
                  dataKey: "area",
                },
              ]}
              name="BarsChart"
              size={{
                height: 330.6667,
                width: "100%",
              }}
              tickAngle={{ xAxis: -30 }}
              label={{ top: "Ålder:", center: "år" }} //This is the tooltip label
            ></Chart>
          ) : volumeAge && ageGraphView == "volume" ? (
            <Chart
              data={ageLabels.map((age, index) => ({
                age: age,
                volume: volumeAge[index],
                unit: "m³sk",
              }))}
              dataKey={{
                xAxis: "age",
              }}
              dataset={[
                {
                  color: "#3F8888",
                  dataKey: "volume",
                },
              ]}
              name="BarsChart"
              size={{
                height: 330.6667,
                width: "100%",
              }}
              tickAngle={{ xAxis: -45 }}
              label={{ top: "Ålder:", center: "år" }} //This is the tooltip label
            />
          ) : null}
        </div>
      </div>
    </>
  );
}
